import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get(`program-course-role-data`)
}
